import { EnvironmentProviders, provideAppInitializer } from '@angular/core';
import { Dialog } from 'primeng/dialog';

let patched = false;

export function provideDialogZoneFix(): EnvironmentProviders {
    return provideAppInitializer(() => {
        if (patched) {
            return;
        }
        patched = true;

        const close = Dialog.prototype.close;
        Dialog.prototype.close = function (this: Dialog, event: Event): void {
            this.zone.run(() => close.call(this, event));
        };
    });
}
